import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Multi-model switching store
 * Persists the selected model in localStorage so the choice survives reloads.
 */
export const useModelStore = create(
  persist(
    (set) => ({
      /** @type {'gpt4o' | 'claude35Sonnet' | 'tongyi' | 'deepseek' | 'fastgpt'} */
      currentModel: 'gpt4o',
      /**
       * @param {string} modelId
       */
      setModel: (modelId) => set({ currentModel: modelId }),
    }),
    {
      name: 'simon-cat-model',
      partialize: (state) => ({ currentModel: state.currentModel }),
    }
  )
);
